import { useField } from "formik";
import Tiptap from "./Tiptap";
import React, { useCallback } from "react";

const TipTapFormik = ({ name, setFieldValue, preview }: any) => {
  const [field] = useField(name);

  const handleChange = useCallback(
    (value: any) => {
      setFieldValue(name, value);
    },
    [setFieldValue, name]
  );

  return (
    <Tiptap
      initialValue={field.value}
      onChange={handleChange}
      preview={preview}
    />
  );
};

export default React.memo(TipTapFormik);
